import { writable } from 'svelte/store'
export const setEditProfile = writable({edit:false})